const map = {
	"./2k.png": 27462,
	"./Bhabua-Cement-Plant.jpg": 17073,
	"./Bhiwani-Cement-Plant.jpg": 8074,
	"./Bhiwani-Cement-Plant.png": 1870,
	"./CSRBanner.jpeg": 73250,
	"./CSRBanner.png": 50573,
	"./CSRBannerMobile.png": 41767,
	"./Chittor-Cement-Plant.jpg": 32685,
	"./Chittor-Cement-Plant1.png": 90400,
	"./EmployeeEngament.png": 86322,
	"./Eshiksha.jpg": 27213,
	"./Eshiksha.png": 10397,
	"./GPTW_Web_ Nuvoco.jpg": 38687,
	"./Girls-Health-Group.jpg": 90593,
	"./Governance.jpg": 12191,
	"./H&S-Initiatives-24.png": 90017,
	"./Health-and-safety-icon.png": 24866,
	"./HealthSafetyBanner.png": 74501,
	"./IRIM.jpg": 30196,
	"./ImpactAssessmentReport2024.jpg": 50169,
	"./ImpactAssessmentReport2024.png": 48257,
	"./Jajpur-Cement-Plant.jpg": 9586,
	"./Jajpur-Cement-Plant.png": 56214,
	"./Jal-Sanchay-After.png": 81309,
	"./Jal-Sanchay-Before.png": 91146,
	"./Jal-Sanchay.jpg": 43520,
	"./Jal-Sanchay.png": 72612,
	"./Jojobera-Cement-Plant.jpg": 41874,
	"./Kutch-Cement-Plant.png": 82813,
	"./Mejia-Cement-Plant.jpg": 4816,
	"./Mejia-Cement-Plant.png": 19092,
	"./Mobile-Medical-Sevices.png": 67918,
	"./Nimbol-Cement-Plant.jpg": 55699,
	"./Nimbol-Cement-Plant.png": 49435,
	"./Nuvo-Mason.png": 91464,
	"./Panagarh-Cement-Plant.jpg": 49654,
	"./Panagarh-Cement-Plant.png": 75378,
	"./Project-Tara.png": 94349,
	"./ProjectSamriddhi.png": 81,
	"./Repair-Solutions.jpg": 50103,
	"./Repair-Solutions.png": 21575,
	"./Risda-Cement-Plant.jpg": 80363,
	"./Risda-Cement-Plant.png": 88947,
	"./Roof_Shield.png": 58221,
	"./Shikshit-Sunderhattu.jpg": 31904,
	"./Shishir-Desai.png": 67428,
	"./SolarBackupinhospitals.png": 14014,
	"./Sonadih-Cement-Plant.jpg": 90086,
	"./Sonadih-Cement-Plant.png": 30626,
	"./Surat-Cement-Plant.png": 53505,
	"./Swasth-Matritva.jpg": 31788,
	"./Tile-Stone-Fixing-solutions.jpg": 49182,
	"./Tile-Stone-Fixing-solutions.png": 67130,
	"./Total-Rewards.png": 86706,
	"./Tree-Plantation.png": 15104,
	"./Web-BannerNew.png": 47842,
	"./about-icon1.jpg": 12675,
	"./about01.png": 36957,
	"./about02.png": 55750,
	"./about03.png": 94767,
	"./about04.png": 82544,
	"./aboutba-logo.png": 88639,
	"./abouticon2.jpg": 8601,
	"./abouticon2.png": 90337,
	"./abouticon3.jpg": 64252,
	"./abouticon3.png": 17624,
	"./abouticon4.jpg": 18663,
	"./abouticon4.png": 97239,
	"./abouticon5.jpg": 6506,
	"./abouticon5.png": 23598,
	"./aboutus-banner-mobile.jpg": 30906,
	"./aboutus-banner.jpg": 79285,
	"./aboutus-banner.png": 58309,
	"./akriti.jpg": 47521,
	"./akriti.png": 91337,
	"./ancillary-solutions-category6-mobile.png": 40073,
	"./ancillary-solutions-category6.jpg": 80132,
	"./ancillary-solutions-category6.png": 79232,
	"./ancillary-solutions.jpg": 72745,
	"./ancillary-solutions.png": 66385,
	"./annualIcon.png": 31961,
	"./annualreportBanner.jpg": 80302,
	"./annualreportBanner.png": 35018,
	"./application.png": 57673,
	"./arasmeta-cement-plant.jpg": 28992,
	"./arrofull.png": 36376,
	"./arrow-rot.png": 7944,
	"./arrow.png": 44504,
	"./arrow_right.png": 60043,
	"./artist-bare.png": 62949,
	"./artist-lumos.png": 2141,
	"./artiste.png": 1269,
	"./artistelogo05.png": 51065,
	"./artists-coarse.png": 14161,
	"./artists-engrave.png": 32808,
	"./artists-hug.png": 45364,
	"./assit01.png": 65294,
	"./assit02.png": 53445,
	"./assit03.png": 24028,
	"./assit04.png": 7635,
	"./audit.png": 71614,
	"./award-blur.jpg": 14184,
	"./awardCommon.jpg": 67483,
	"./banner-vadraj-cement-m.jpg": 73377,
	"./banner-vadraj-cement.jpg": 5179,
	"./banner-vadraj-cement.png": 32451,
	"./banner.jpg": 55201,
	"./banner1.jpg": 17088,
	"./banner2.jpg": 30703,
	"./banner3.jpg": 46418,
	"./banner3.png": 41462,
	"./banner4.jpg": 14433,
	"./banner5.jpg": 36388,
	"./banner6.jpg": 88019,
	"./barndlogo.png": 59171,
	"./bhabua-new.png": 96723,
	"./blog.jpg": 2575,
	"./blog01.png": 48310,
	"./blog02.png": 80077,
	"./blog03.png": 484,
	"./blog04.png": 55291,
	"./blog05.png": 50098,
	"./bod-logo.png": 84366,
	"./bod02.jpg": 73954,
	"./bod03.jpg": 86623,
	"./bod04.jpg": 65812,
	"./bod05.jpg": 63185,
	"./bord_of_directors-mobile.jpg": 34313,
	"./bord_of_directors.jpg": 17804,
	"./bord_of_directors.png": 43720,
	"./brand01.png": 81181,
	"./brand02.png": 13766,
	"./brand03.png": 82511,
	"./brand04.png": 86640,
	"./brand05.png": 2393,
	"./brand06.png": 88386,
	"./brand07.png": 52043,
	"./brandstory-mobile.jpg": 11266,
	"./brandstory.jpg": 41821,
	"./brandstory.png": 57293,
	"./btnicon.png": 37912,
	"./business1.jpg": 35836,
	"./business2.jpg": 27819,
	"./business3.jpg": 49774,
	"./ce1.jpg": 41322,
	"./ce2.jpg": 17045,
	"./cement-banner-mobile.jpg": 37953,
	"./cement-banner.jpg": 8036,
	"./cementHome.jpg": 31290,
	"./cementIcon.png": 93432,
	"./cement_logo.svg": 7775,
	"./cementba-logo.png": 24494,
	"./chart.jpg": 99467,
	"./chat-icon.png": 6687,
	"./circle.png": 85919,
	"./clogo01.png": 54176,
	"./clogo02.png": 51739,
	"./clogo03.png": 30194,
	"./clogo04.png": 60173,
	"./closeicon.png": 87948,
	"./coffee-table-img-25-26.jpg": 63117,
	"./coffee-table-img.jpg": 60738,
	"./concreto-agile-flow.png": 46442,
	"./concreto-agile.png": 62435,
	"./concreto-corrosafe-plus.png": 90748,
	"./concreto-cwt-plus.png": 38096,
	"./concreto-easyfille.png": 74641,
	"./concreto-ecodure.png": 30758,
	"./concreto-fluide.png": 8234,
	"./concreto-glyde-logo.png": 97606,
	"./concreto-instante.png": 87843,
	"./concreto-lente.png": 15571,
	"./concreto-permadure.png": 25658,
	"./concreto-polibre.png": 62672,
	"./concreto-regletherme.png": 63807,
	"./concreto-robuste.png": 82759,
	"./concreto-steelibre.png": 26068,
	"./concreto-xlite-structure.png": 60119,
	"./concreto-xlite.png": 9979,
	"./concreto.jpg": 90060,
	"./concreto.png": 92680,
	"./construction.png": 77852,
	"./contact-us-mobile.jpg": 98759,
	"./contact_icon.png": 49959,
	"./contact_us.jpg": 69544,
	"./contact_us.png": 55180,
	"./corporate-governance-mobile.jpg": 6182,
	"./corporate_governance.jpg": 85943,
	"./corporate_governance.png": 73767,
	"./corporateicon.png": 36457,
	"./cost.png": 18252,
	"./daksh.jpg": 42978,
	"./daksh.png": 40358,
	"./dbull.png": 76444,
	"./dcement.png": 55535,
	"./disclaimerBanner.jpg": 98732,
	"./disclaimerBannerMobile.jpg": 95526,
	"./doubicon.png": 90358,
	"./duraguardsilver50kg.jpg": 47608,
	"./durga-puja-press-release.jpg": 22993,
	"./ecodure-product.png": 35816,
	"./ecodure.png": 962,
	"./email.png": 60003,
	"./employee-engagement.jpg": 63411,
	"./employee.jpg": 5635,
	"./envirimg1.png": 51149,
	"./envirimg10.png": 8217,
	"./envirimg11.png": 27664,
	"./envirimg12.png": 81163,
	"./envirimg13.png": 60034,
	"./envirimg14.png": 56381,
	"./envirimg2.png": 37174,
	"./envirimg3.png": 34111,
	"./envirimg4.png": 82784,
	"./envirimg5.png": 60905,
	"./envirimg6.png": 46290,
	"./envirimg7.png": 61115,
	"./envirimg8.png": 81228,
	"./envirimg9.png": 17141,
	"./envirmentBanner-mobile.jpg": 54986,
	"./envirmentBanner.jpg": 34341,
	"./envirmentBanner.png": 38165,
	"./envirmenticon.png": 95996,
	"./environment-home.jpg": 14846,
	"./environment-homenew.jpg": 7198,
	"./esgBanner.jpg": 25230,
	"./esgBanner.png": 96298,
	"./esgicon.png": 2759,
	"./evp.png": 40496,
	"./facebook-logo.png": 42615,
	"./fake-employement.jpg": 85412,
	"./fb.png": 16627,
	"./fb1.png": 83474,
	"./floors-00.jpg": 9377,
	"./floors-01.jpg": 35780,
	"./floors-02.jpg": 62003,
	"./floors-03.jpg": 33590,
	"./footer.jpg": 58958,
	"./footer_logo.png": 26274,
	"./footermobileBg.jpg": 92897,
	"./footprint01.png": 46379,
	"./footprint02.png": 32560,
	"./footprint03.png": 38809,
	"./footprint04.png": 36390,
	"./footprint07.png": 17597,
	"./footprint08.png": 6826,
	"./footprint09.png": 38739,
	"./fountains.png": 36708,
	"./get_in.jpg": 28293,
	"./governance-home.jpg": 69651,
	"./governance-homenew.jpg": 56297,
	"./governance_Mobile.jpg": 37894,
	"./green.jpg": 72894,
	"./green.png": 19130,
	"./growth-accelerator.jpg": 81376,
	"./growth-accelerator.png": 17412,
	"./gst-banner.jpg": 68130,
	"./gst-reform-inner.png": 84306,
	"./gujarati-em-launch-1920x960.png": 70449,
	"./health-and-safety-banner-mobile.jpg": 61448,
	"./health-and-safety-banner-mobile.png": 97612,
	"./health-and-safety-banner.jpg": 4807,
	"./home-page-Web-Banner-1-mobile.png": 23129,
	"./home-page-Web-Banner-1.jpg": 78420,
	"./home-page-Web-Banner-1.png": 30640,
	"./home_about.jpg": 68184,
	"./home_asist.jpg": 91039,
	"./house.png": 84527,
	"./hr.png": 99393,
	"./ig.png": 71639,
	"./ig1.png": 40494,
	"./img4.png": 59664,
	"./in.png": 8582,
	"./in1.png": 18333,
	"./infra1.png": 72692,
	"./infra2.png": 95151,
	"./infracem.png": 86792,
	"./ingallery01.jpg": 38315,
	"./ingallery02.jpg": 96796,
	"./ingallery03.jpg": 41145,
	"./ingallery04.jpg": 55402,
	"./ingallery05.jpg": 67559,
	"./ingallery06.jpg": 34712,
	"./ingallery07.jpg": 95893,
	"./ingallery08.jpg": 59686,
	"./inn-banner-mobile.jpg": 15940,
	"./inn-banner.jpg": 35507,
	"./inn-banner.png": 12891,
	"./inn1.png": 56361,
	"./inn2.png": 91218,
	"./inn3.png": 56571,
	"./inn4.png": 46628,
	"./inn5.png": 72781,
	"./inn6.png": 82102,
	"./innba-logo.png": 32737,
	"./instamix.jpg": 9742,
	"./instamix.png": 57514,
	"./instamix01.jpg": 50483,
	"./instamix02.jpg": 72676,
	"./instamix03.jpg": 50721,
	"./instamix_banner.jpg": 69309,
	"./instamixbaggedconcrete.png": 88889,
	"./instamixbondaid50kg.png": 95814,
	"./instamixmicrone.png": 12147,
	"./instamixmortareradymixmortar.png": 12397,
	"./instamixplastosmart.png": 37706,
	"./instamixxpress.png": 90235,
	"./internet-career-website-m.jpg": 10355,
	"./internet-career-website.jpeg": 53050,
	"./investericon.png": 4690,
	"./investor-corner-mobile.jpg": 51818,
	"./investors_corner.jpg": 18450,
	"./investors_corner.png": 22550,
	"./jobs.jpg": 26171,
	"./joinlife.jpg": 94637,
	"./journey-banner-mobile.jpg": 68693,
	"./journey-banner.jpg": 29032,
	"./journey-banner.png": 7724,
	"./journey-bg.png": 38439,
	"./journeyba-logo.png": 65970,
	"./jr1.png": 1990,
	"./jr10.png": 884,
	"./jr11.png": 38365,
	"./jr12.png": 97126,
	"./jr2.png": 99549,
	"./jr3.png": 66516,
	"./jr4.png": 16427,
	"./jr5.png": 95298,
	"./jr6.png": 51385,
	"./jr7.png": 45136,
	"./jr8.png": 65047,
	"./jr9.png": 19470,
	"./landmark01.jpg": 25430,
	"./landmark01.png": 26034,
	"./landmark02.jpg": 1217,
	"./landmark02.png": 74217,
	"./landmark03.png": 50016,
	"./landmark04.png": 78047,
	"./landmark05.png": 24246,
	"./landmark06.png": 56013,
	"./landmark07.png": 92772,
	"./landmark08.png": 92963,
	"./landmark09.png": 3130,
	"./landmarkcenter01.jpg": 48473,
	"./landmarkcenter02.jpg": 75982,
	"./landmarkcenter03.jpg": 2443,
	"./landmarkcenter04.jpg": 79608,
	"./landmarkcenter05.jpg": 86869,
	"./landmarkcenter06.jpg": 19530,
	"./landmarkcenter07.jpg": 58535,
	"./landmarkcenter08.jpg": 76884,
	"./landmarkcenter09.jpg": 55409,
	"./landmarkcenter10.jpg": 27451,
	"./learning-Development.png": 71181,
	"./learning-developemnt.jpg": 35933,
	"./learning.jpg": 50405,
	"./life-at-nuvoco-mobile.jpg": 98727,
	"./life01.png": 65476,
	"./life02.png": 50751,
	"./life03.png": 96950,
	"./life04.png": 46921,
	"./life05.png": 22720,
	"./life06.png": 20283,
	"./life07.png": 76357,
	"./life08.png": 27893,
	"./lifeaticon.png": 75625,
	"./lifeatnuvocobanner.jpg": 1488,
	"./lifestNuvocoBanner.png": 78006,
	"./lifestNuvocoMobileBanner.png": 78688,
	"./linkedIn-logo.png": 89069,
	"./location.png": 64318,
	"./logo.png": 82806,
	"./map.jpg": 50081,
	"./marker.png": 62333,
	"./marker.svg": 96329,
	"./mbm-banner.jpg": 59942,
	"./mbm-banner.png": 81250,
	"./mbm01.jpg": 63868,
	"./mbm02.jpg": 55851,
	"./mbm03.jpg": 77806,
	"./mbm04.png": 19301,
	"./mbm_img.jpg": 69605,
	"./mbmt1t2.png": 86714,
	"./mbuilding.jpg": 44398,
	"./media.png": 47391,
	"./media_banner.jpg": 21406,
	"./media_banner.png": 67642,
	"./mediaicon.png": 67708,
	"./message.png": 84766,
	"./nabl.jpg": 67066,
	"./name.png": 6282,
	"./new-logo-description.jpg": 68960,
	"./newbanner1-m.jpg": 66580,
	"./newbanner1.jpg": 82514,
	"./newbanner1_hi.jpg": 46878,
	"./newbanner1_hi_m.jpg": 68870,
	"./newbanner2.png": 60909,
	"./newbanner3.jpg": 68576,
	"./newbanner4.jpg": 58739,
	"./news01.jpg": 45775,
	"./news02.jpg": 48512,
	"./news03.jpg": 87741,
	"./news04.png": 82002,
	"./news05.png": 96827,
	"./nirmaanbahini.jpg": 82350,
	"./nirmex.png": 44944,
	"./nuvoco-partnership.jpg": 8280,
	"./our-brand-story-banner.jpg": 53994,
	"./our-brand-story-banner.png": 54734,
	"./our-brand-story-img-1.png": 23977,
	"./our-brand-story-img-2.jpg": 67286,
	"./our-brand-story-img-2.png": 9362,
	"./our-cement-banner-mobile.jpg": 80578,
	"./our-cement-banner.jpg": 6941,
	"./our-cement-banner.png": 31181,
	"./our-cement-icon.png": 96740,
	"./our-mbm-icon.png": 61504,
	"./our-rmc-banner-mobile.jpg": 81270,
	"./our-rmc-banner.jpg": 87169,
	"./our-rmc-banner.png": 30985,
	"./ourbrand.jpg": 96790,
	"./ourbs01.png": 91637,
	"./ourbs02.png": 71262,
	"./partner.png": 44445,
	"./pdf_icon.png": 8205,
	"./pen-icon.png": 74654,
	"./people.jpg": 56326,
	"./performace-highlight-mobile.jpg": 35141,
	"./performance_highlight.jpg": 80108,
	"./performance_highlight.png": 48552,
	"./performanceicon.png": 14650,
	"./phone.png": 83351,
	"./pincode.png": 10889,
	"./popoverlaybg.jpg": 7673,
	"./ppc43.png": 92375,
	"./ppc53.png": 37292,
	"./psc.png": 53065,
	"./ready_mix.jpg": 42321,
	"./repair-solutions-category5-mobile.png": 72162,
	"./repair-solutions-category5.jpg": 93297,
	"./repair-solutions-category5.png": 72665,
	"./right-arrow.png": 53809,
	"./right_icon.png": 4577,
	"./right_icon_g.png": 75607,
	"./rmcIcon.png": 2562,
	"./rmxconcreto.png": 76545,
	"./safer.jpg": 85448,
	"./safer2018.jpg": 81041,
	"./safer2019-1.png": 77678,
	"./safer2019-2.png": 65829,
	"./safer2019.jpg": 83668,
	"./safer20201.jpg": 2479,
	"./safer20202.jpg": 5216,
	"./safer20221.jpg": 50965,
	"./samridhi.jpg": 39632,
	"./scale.jpeg": 37026,
	"./selbg.png": 46026,
	"./shareholder.png": 91092,
	"./smart.jpg": 27236,
	"./smart1.jpg": 54371,
	"./smart2.jpg": 52564,
	"./smarter2018.jpg": 58596,
	"./smarter2020.jpg": 40989,
	"./smarter20201.jpg": 68724,
	"./smarter20202.jpg": 98435,
	"./smarter20211.jpg": 65623,
	"./smarter20221.jpg": 76674,
	"./smarter20222.jpg": 25165,
	"./smarter20223.jpg": 81712,
	"./smarter20224.jpg": 12867,
	"./smarticon.png": 38767,
	"./smarticon1.png": 48918,
	"./smarticon2.png": 30541,
	"./social-home.jpg": 25904,
	"./social-homenew.jpg": 56244,
	"./socialBanner.jpg": 35664,
	"./socialIcon.png": 20053,
	"./socialbicon1.png": 69600,
	"./socialbicon2.png": 31579,
	"./socialbicon3.png": 16754,
	"./socialbicon4.png": 21613,
	"./socialbicon5.png": 67716,
	"./sortby.png": 47152,
	"./speaker.png": 98216,
	"./sra-banner.jpg": 28924,
	"./st_bg.jpg": 48478,
	"./stand1icon.png": 33133,
	"./stand2icon.png": 28986,
	"./stand3icon.png": 83927,
	"./stand4icon.png": 26404,
	"./stand5icon.png": 81649,
	"./stand6icon.png": 97278,
	"./stand7icon.png": 88603,
	"./stand8icon.png": 25848,
	"./stand9icon.png": 15317,
	"./standcement.png": 53131,
	"./subhpremiumpsc.png": 39098,
	"./surface-preperation-solutions-category4-mobile.png": 12767,
	"./surface-preperation-solutions-category4.jpg": 1118,
	"./surface-preperation-solutions-category4.png": 19066,
	"./surface-preperation-solutions.jpg": 64641,
	"./surface-preperation-solutions.png": 8457,
	"./sus01.png": 9469,
	"./sus03.png": 67279,
	"./sus04.png": 71408,
	"./sus05.png": 61305,
	"./sus06.png": 21570,
	"./sus07.png": 42699,
	"./sus08.png": 33212,
	"./sus09.png": 99749,
	"./sus10.png": 19743,
	"./sus11.png": 41654,
	"./susBanner.jpg": 99394,
	"./susbanner-mobile.jpg": 28931,
	"./susicon.png": 29883,
	"./sustainable2018.jpg": 12973,
	"./sustainable2020.jpg": 6916,
	"./sustainable20222.jpg": 70750,
	"./sustainable20223.jpg": 41883,
	"./team_logo.png": 76612,
	"./team_managment-mobile.jpg": 4230,
	"./team_managment.jpg": 87313,
	"./team_managment.png": 32505,
	"./tile-stone-fixing-solutions2-mobile.jpg": 903,
	"./tile-stone-fixing-solutions2-mobile.png": 22007,
	"./tile-stone-fixing-solutions2.jpg": 95670,
	"./tile-stone-fixing-solutions2.png": 37746,
	"./total-rewards.jpg": 80662,
	"./total.jpg": 93541,
	"./tw.png": 47032,
	"./tw1.png": 93235,
	"./vimi-banner-mobile.jpg": 15584,
	"./vimi-banner.jpg": 97279,
	"./vimi-banner.png": 24559,
	"./vimi1.png": 89853,
	"./vimi2.png": 8646,
	"./vimi3.png": 47663,
	"./vimi4.png": 51792,
	"./vimi5.png": 58041,
	"./vimi6.png": 1954,
	"./vimi7.png": 23083,
	"./vimiba-logo.png": 97117,
	"./watapp.png": 79570,
	"./waterproofing-solutions-3-mobile.png": 93732,
	"./waterproofing-solutions-3.png": 27535,
	"./waterproofing-solutions-4.png": 1040,
	"./waterproofing-solutions.jpg": 3619,
	"./waterproofing-solutions.png": 7531,
	"./xcon.png": 64583,
	"./xconlogo.png": 6354,
	"./yoga-social.jpg": 40643,
	"./yt.png": 76892,
	"./yt1.png": 88783,
	"./zero-m-iwc.png": 21767,
	"./zeroM.png": 82756,
	"./zeromacrylicpower3.png": 43193,
	"./zeromcoverblock8.png": 87554,
	"./zeromgermicheckwallputty6.png": 64780,
	"./zeromlatexexpert4.png": 52812,
	"./zerompolyrichwallputty7.png": 88813,
	"./zeromspeedextileadhesive5.png": 95192,
	"./zeromspeedextilegrout9.png": 29334,
	"./zeromwatershieldiwc1.png": 85912,
	"./zeromwatershieldkee.jpeg": 41152,
	"./zerowatershield2.png": 41041
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53793;